import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value).format('DD.MM.YYYY');
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm:ss');
    }
});

Vue.filter('formatDateTimeNoSec', function(value) {
    if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm');
    }
});

Vue.filter('fromNow', function(value) {
    return moment(value).fromNow();
});

Vue.filter('truncate', function (text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
})
